export default __webpack_public_path__ + "static/media/item_4@2x.4e98f86a.webp";